import UserIcon from '@/common/assets/icons/user.svg?react';
import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import Typography from '@/common/components/base/typography/Typography';
import { Box, Flex } from 'styled-system/jsx';
import { InformationIconHeaderPropsTypes } from '@/modules/FileDetail/components/headers/InformationIconHeader.types.ts';

export default ({
  index,
  isApplicantUser,
}: InformationIconHeaderPropsTypes) => (
  <Flex
    px="20px"
    py="8px"
    justifyContent="space-between"
    alignItems="center"
    borderBottom="2px dashed {colors.gray-2}"
  >
    <Flex alignItems="center">
      {index ? (
        <Typography
          textStyle="b4"
          color="black-4"
          pl="15px"
          pr="5px"
          borderLeft="1px solid {colors.gray-2}"
          ml="15px"
        >
          {index}
        </Typography>
      ) : null}
      <UserIcon />
    </Flex>

    {isApplicantUser && (
      <Box>
        <CustomLabel title="اعلام کننده" color="purpleLight" />
      </Box>
    )}
  </Flex>
);
